function toLowerCase(data) {
    const str = data.replace(/([A-Z])/g, '_$1').toLowerCase()
    return str
}

export default toLowerCase